import React from 'react';
import PropTypes from 'prop-types';
import { makeStyles } from '@material-ui/core/styles';
import Drawer from '@material-ui/core/Drawer';
import MuiContainer from '@material-ui/core/Container';
import CloseButtonSideBar from '../../molecules/CloseButtonSideBar';
import { MenuSideBar } from '../../molecules/MenuSideBar';
import { listaMenuSideBar } from '../../../helpers/rota.helper';
import { Image } from '../../molecules/Image';
import imageLogo from '../../../assets/svgs/logo_co_cor.svg';

const useStyles = makeStyles({
    root: () => ({
        display: 'flex'
    }),
    drawer: ({ drawerWidth }) => ({
        width: drawerWidth,
        flexShrink: 0
    }),
    drawerPaper: ({ drawerWidth }) => ({
        width: drawerWidth
    })
});

const SideBar = ({
    isOpen,
    close,
    nomeUsuario,
    permissoes,
    matches,
    varient,
    drawerWidth
}) => {
    const classes = useStyles({
        drawerWidth
    });

    const temporaryClose = () => {
        if (!matches) {
            close();
        }
    };

    const alturaImagem = 58;
    return (
        <Drawer
            className={classes.drawer}
            variant={varient}
            anchor='left'
            open={isOpen}
            classes={{
                paper: classes.drawerPaper
            }}
            onClick={temporaryClose}
            onKeyDown={temporaryClose}
        >
            <CloseButtonSideBar nome={nomeUsuario} close={close} />
            <MuiContainer
                style={{
                    display: 'flex',
                    margin: `0px`,
                    padding: '0px',
                    height: '100%',
                    width: '100%',
                    flexDirection: 'column'
                }}
            >
                <MenuSideBar
                    listaMenu={listaMenuSideBar()}
                    permissoes={permissoes}
                    marignBottom={alturaImagem + 10}
                />
                <Image
                    src={imageLogo}
                    alt='CO Digital'
                    title='CO Digital'
                    width='110px'
                    height={`${alturaImagem}px`}
                    style={{ margin: '14px 0px 14px 21px' }}
                />
            </MuiContainer>
        </Drawer>
    );
};

SideBar.propTypes = {
    isOpen: PropTypes.bool.isRequired,
    close: PropTypes.func.isRequired,
    nomeUsuario: PropTypes.string.isRequired,
    permissoes: PropTypes.arrayOf(PropTypes.string).isRequired,
    matches: PropTypes.bool.isRequired,
    varient: PropTypes.string.isRequired,
    drawerWidth: PropTypes.number.isRequired
};

function moviePropsAreEqual(prevProps, nextProps) {
    return (
        prevProps.isOpen === nextProps.isOpen &&
        prevProps.nomeUsuario === nextProps.nomeUsuario &&
        prevProps.permissoes === nextProps.permissoes &&
        prevProps.matches === nextProps.matches &&
        prevProps.varient === nextProps.varient &&
        prevProps.drawerWidth === nextProps.drawerWidth
    );
}

export default React.memo(SideBar, moviePropsAreEqual);
